import Vue from 'vue';

// routers 设定
import VueRouter from 'vue-router';
import fullscreenRouters from './fullscreen-router';
import menuRouters from './menu-router';  // 展示在菜单中的路由
import menuOtherRouters from './menu-other-router'; // 不展示在菜单中的详情页路由

// vuex store
import store from '../store/index';

// 路由配置
Vue.use(VueRouter);

// 路由包括菜单路由和其它路由
let allMenus = menuRouters.concat(fullscreenRouters, menuOtherRouters);

const RouterConfig = {
    mode: 'history', // 去除路由中的# 
    routes: allMenus
};
const router = new VueRouter(RouterConfig);

// 路由前置操作
router.beforeEach((to, from, next) => {
    // store.commit('updateBreadCrumb', to);
    if (to.meta.current) {
        store.commit('setCurMenuRouter', to.meta.current[0]);
        // store.commit('setCurMenuRouter',to.meta.parent);
        store.commit('setCurMenuOpened', to.meta.parent);
        next();
    }else{
        next();
    }
    
});

export default router;